/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'

import { SkeletonRow } from 'src/components/ts-components/SkeletonBlock'

const TILE_COUNT = 3

/** Cold-load placeholder for the Progress card body: tiles row + chart box. */
const ProgressCardSkeleton = () => {
  'use memo'

  return (
    <div aria-hidden='true' css={wrapStyles}>
      <div css={tilesStyles}>
        {Array.from({ length: TILE_COUNT }, (_, i) => (
          <SkeletonRow key={i} height={72} />
        ))}
      </div>
      <SkeletonRow height={280} />
    </div>
  )
}

// ─── Styles ──────────────────────────────────────────────────────

const wrapStyles = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const tilesStyles = css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
`

export default ProgressCardSkeleton
